import { Tab, Tabs } from '@mui/material';
import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import Icon from '../../components/Icon';

const PPSideBar = (props) => {
  const {
    activeTab,
    onChange,
    className,
    tabs = [],
    'data-testid': testId,
  } = props;

  const [expandedParents, setExpandedParents] = useState({});

  // Auto-expand parent if a child is active, collapse if other tabs are selected
  useEffect(() => {
    tabs.forEach((tab) => {
      if (tab.isParent && tab.children) {
        const hasActiveChild = tab.children.some(
          (child) => activeTab === child.url,
        );
        if (hasActiveChild) {
          // Expand if a child is active
          setExpandedParents((prev) => ({
            ...prev,
            [tab.value]: true,
          }));
        } else {
          // Collapse if no child is active (other tab selected)
          setExpandedParents((prev) => ({
            ...prev,
            [tab.value]: false,
          }));
        }
      }
    });
  }, [activeTab, tabs]);

  const toggleParent = (parentValue, event) => {
    if (event) {
      event.stopPropagation();
    }
    setExpandedParents((prev) => ({
      ...prev,
      [parentValue]: !prev[parentValue],
    }));
  };

  const renderTab = (tab) => {
    const isActiveTab = activeTab === tab.url;
    return (
      <Tab
        key={tab.url}
        className={`${styles.tab_item} ${isActiveTab && styles.active}`}
        iconPosition="start"
        icon={
          isActiveTab ? (
            <Icon name="green_circle" width="12" height="12" />
          ) : (
            <Icon name="black_circle" width="12" height="12" />
          )
        }
        value={tab.url}
        label={tab.label}
      />
    );
  };

  // Get only non-parent tabs for the Tabs component
  const regularTabs = tabs.filter((tab) => !tab.isParent);

  return (
    <>
      <div
        data-testid={testId}
        className={`${styles.sidebar_container} ${className}`}>
        <div className={styles.sidebar_content}>
          <div className={styles.sidebar_heading}> Production Planning </div>
          {activeTab && (
            <div className={styles.tab_items_container}>
              {tabs.map((each) => {
                if (each.isParent && each.children) {
                  const isExpanded = expandedParents[each.value];
                  const hasActiveChild = each.children.some(
                    (child) => activeTab === child.url,
                  );

                  return (
                    <div
                      key={each.value}
                      className={styles.parent_tab_container}>
                      <div
                        role="button"
                        tabIndex={0}
                        className={`${styles.parent_tab} ${
                          hasActiveChild ? styles.active_parent : ''
                        }`}
                        onClick={(e) => toggleParent(each.value, e)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleParent(each.value, e);
                          }
                        }}>
                        <Icon
                          name={
                            hasActiveChild ? 'green_circle' : 'black_circle'
                          }
                          width="12"
                          height="12"
                        />
                        <span className={styles.parent_label}>
                          {each.label}
                        </span>
                      </div>
                      {isExpanded && (
                        <div className={styles.children_container}>
                          {each.children.map((child) => {
                            const isActiveTab = activeTab === child.url;
                            return (
                              <div
                                key={child.url}
                                role="button"
                                tabIndex={0}
                                className={`${styles.child_tab_item} ${
                                  isActiveTab ? styles.active : ''
                                }`}
                                onClick={() => onChange(null, child.url)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onChange(null, child.url);
                                  }
                                }}>
                                <Icon
                                  name={
                                    isActiveTab
                                      ? 'green_circle'
                                      : 'black_circle'
                                  }
                                  width="10"
                                  height="10"
                                />
                                <span className={styles.child_label}>
                                  {child.label}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }
                return null;
              })}
              {regularTabs.length > 0 && (
                <Tabs
                  className={styles.tabs_wrapper}
                  classes={{ indicator: styles.display_none }}
                  orientation="vertical"
                  variant="scrollable"
                  value={activeTab}
                  onChange={onChange}
                  aria-label="Production Planning Tabs">
                  {regularTabs.map((tab) => renderTab(tab))}
                </Tabs>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PPSideBar;
